import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import queryString from 'query-string';
export const getPartnerAuditLogsData = function getPartnerAuditLogsData(mpacBaseUrl, partnerId) {
  let queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/auditlog/").concat(partnerId, "?").concat(queryString.stringify(queryParams))).then(response => response.json());
};